import { render } from "./FilterPager.vue?vue&type=template&id=20fec71c"
import script from "./FilterPager.vue?vue&type=script&lang=js"
export * from "./FilterPager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__